import React, { Suspense } from 'react';
import Spinner from '../../components/bootstrap/Spinner';
import ContentRoutes from './ContentRoutes';

/**
 * 页面加载中组件
 */
const PageLoading = () => (
  <div
    className='d-flex flex-column align-items-center justify-content-center w-100'
    style={{ height: 'calc(100vh - 120px)' }}>
    <Spinner size='3rem' color='primary' />
    <div className='mt-3 text-muted'>Loading...</div>
  </div>
);

const Content = () => {
  return (
    <main className='content'>
      <Suspense fallback={<PageLoading />}>
        <ContentRoutes />
      </Suspense>
    </main>
  );
};

export default Content;
